{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              13.430859918667693,
              45.51233387142054
            ],
            [
              13.474763858105831,
              45.00675458162431
            ],
            [
              15.307442111377554,
              43.55153942995349
            ],
            [
              16.730955562735915,
              42.6291823280211
            ],
            [
              18.63986680037891,
              42.35214132998615
            ],
            [
              15.068304367378403,
              45.476084182773434
            ],
            [
              13.430859918667693,
              45.51233387142054
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}